<template>
    <div class="the-parent">
        <section-header
            ref="selectHeader"
            title="Set Reference Category"
        ></section-header>
        <div>
            This procedure allows you to calculate the effect of one or more
            predictors, or independent variables, on a dependent variable that
            has two levels (for example, "at risk" and "not at risk").
        </div>
        <h4>Select the Category for the Dependent Variable</h4>
        <div class="variable-selection">
            <label
                data-toggle="tooltip"
                for="dependentVariable"
                title="Logistic regression models the probability of the dependent variable being equal to a certain level (e.g. high risk or low risk). This selects which level of the dependent variable to model."
            >
                Dependent Variable ({{ dependentVariable.variableTitle }})
            </label>
        </div>
        <div class="col-md-11 col-md-offset-1">
            <div class="form-group">
                <div
                    class="radio"
                    v-for="category in dependentVariable.categories"
                    v-bind:key="category.id"
                >
                    <label>
                        <input
                            name="depvar_model_level"
                            type="radio"
                            v-bind:value="category.id"
                            v-model="reference.dependent"
                        />
                        {{ category.title }}
                    </label>
                </div>
            </div>
        </div>
        <h4>
            Select the Category for the Independent
            {{ independentVariables.length > 1 ? 'Variables' : 'Variable' }}
        </h4>
        <div
            v-for="(variable, variableIndex) in independentVariables"
            v-bind:key="'ind_cat' + variableIndex"
        >
            <div class="variable-selection">
                <label
                    data-toggle="tooltip"
                    title="Logistic regression models the probability of the dependent variable being equal to a certain level (e.g. high risk or low risk). This selects which level of the dependent variable to model."
                >
                    {{ getNumeral(variableIndex) }} independent Variable ({{
                        variable.variableTitle
                    }})
                </label>
            </div>
            <div class="col-md-11 col-md-offset-1 form-group">
                <div
                    class="radio"
                    v-for="category in variable.categories"
                    v-bind:key="'var_cat' + category.id"
                >
                    <label>
                        <input
                            :name="'indepvar_' + variable.variable"
                            type="radio"
                            v-bind:value="category.id"
                            v-model="reference.independent[variableIndex]"
                        />
                        {{ category.title }}
                    </label>
                </div>
            </div>
        </div>
        <app-navigator
            ref="appNavigator"
            :router="$router"
            nextButtonValue="Run Report"
        ></app-navigator>
    </div>
</template>

<script>
/* eslint no-unused-vars: 'off', quotes: 'off' */
import current from '@/scripts/current';
import commonModelHelper from '@/scripts/commonModelHelper';
import sectionHeader from '@/components/sub/sectionHeader';
import store from '@/store';
import appNavigator from '@/components/layout/appNavigator';

export default {
    components: {
        sectionHeader,
        appNavigator
    },
    created: function () {
        const vm = this;
        current.initializeLogisticRegressionValues(vm);
        commonModelHelper.initializeStep(vm, 'setReference');
        let dependentVariable = createVariableModel(
            current.selectionModel.v.dependent.variable
        );
        let independentVariables = current.selectionModel.v.independent.map(
            (v) => createVariableModel(v.variable)
        );
        let s = current.selectionModel;
        if (
            !s.reference ||
            !s.reference.dependent ||
            s.reference.dependent === 0 ||
            s.reference.independent.length === 0
        )
            s.reference = vm.buildReferenceCategories(
                dependentVariable,
                independentVariables
            );
        vm.dependentVariable = dependentVariable;
        vm.independentVariables = independentVariables;
        vm.reference = s.reference;
    },
    data: function () {
        return {
            dependentVariable: null,
            independentVariables: null,
            reference: null
        };
    },
    methods: {
        //nextClicked: function () {
        //  store.dispatch('results/clearLrData');
        //  this.$router.push({ path: current.navigation.getNextPage() });
        //},
        //backClicked: function () {
        //  this.$router.push({ path: current.navigation.getPreviousPage() });
        //},
        buildReferenceCategories: function (
            dependentVariable,
            independentVariables
        ) {
            var vm = this;
            var reference = {
                dependent: vm.getSelectedCategory(dependentVariable),
                independent: independentVariables.map((v) =>
                    vm.getSelectedCategory(v)
                )
            };
            return reference;
        },
        getSelectedCategory: function (v) {
            return v.selectedCategory ? v.selectedCategory.id : 0;
        },
        getNumeral: function (index) {
            var number = index + 1;
            if (number === 1) return number + 'st';
            if (number === 2) return number + 'nd';
            if (number === 3) return number + 'rd';
            if (number >= 4) return number + 'th';
            return number;
        }
    }
};

function createVariableModel(variable) {
    var levels = createLevelModels(variable);
    var model = {
        variableTitle: variable.variableTitle,
        variable: variable.variable,
        categories: levels,
        selectedCategory: levels.length > 0 ? levels[0] : 0
    };
    return model;
}

function createLevelModels(variable) {
    var vm = this;
    if (variable.variable === 'year')
        return store.state.selModel.years.values.map((y, i) => ({
            id: i + 1,
            title: y.toString()
        }));
    if (variable.variable === 'location') {
        return store.state.selModel.locations.allIds.map((id, i) => ({
            id: i + 1,
            title: store.state.selModel.locations.allNames[i]
        }));
    }
    var models = store.state.dataLists.variableDataLists.levels
        .filter((c) => c.var === variable.variable && c.levelNonResponse === 0)
        .map((c) => ({
            inputId: c.var + '_' + c.id,
            id: c.id,
            title: c.title
        }));
    return models;
}
</script>

<style scoped>
.spaced-out {
    margin-top: 20px;
    margin-bottom: 20px;
}

.dropdown-menu label.radio input[type='radio'] {
    visibility: hidden;
}

.dropdown-menu label.radio {
    padding-left: 10px;
}

.shift-up {
    margin-top: -20px;
}

.variable-selection {
    margin-top: 10px;
}

h4 {
    margin-bottom: 0;
    font-weight: 600;
}

.bottom-group {
    width: 100%;
    float: left;
}

.the-parent:after {
    content: ' ';
    display: block;
    clear: both;
}
</style>
